var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-form",
    {
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.formSubmitted($event)
        },
      },
    },
    [
      _c(
        "b-row",
        { staticClass: "justify-content-center" },
        [
          _c(
            "b-col",
            { attrs: { md: "5" } },
            [
              _c(
                "b-card",
                { staticClass: "card-profile" },
                [
                  _c("div", { staticClass: "profile-image-wrapper" }, [
                    _c(
                      "div",
                      { staticClass: "profile-image p-0" },
                      [
                        _c("b-avatar", {
                          attrs: { size: "114", variant: "light" },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "b-row",
                    { staticClass: "justify-content-center mb-4" },
                    [
                      _c("b-col", { attrs: { md: "12" } }, [
                        _c("h2", { staticClass: "font-weight-bolder" }, [
                          _vm._v(_vm._s(_vm.userData.fullName)),
                        ]),
                      ]),
                      _c("b-col", { attrs: { md: "12" } }, [
                        _c("h4", { staticClass: "font-weight-normal" }, [
                          _vm._v(_vm._s(_vm.currentdate)),
                        ]),
                      ]),
                      _c("b-col", { attrs: { md: "12" } }, [
                        _vm.error
                          ? _c("div", [_vm._v(_vm._s(_vm.error))])
                          : _vm._e(),
                        _c("img", { attrs: { src: _vm.mapUrl } }),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "b-row",
                    [
                      _c("b-col", { attrs: { md: "12" } }, [
                        _c("div", { staticClass: "timer-box" }, [
                          _c("div", { staticClass: "time-unit" }, [
                            _vm._v(
                              " " +
                                _vm._s(String(_vm.hours).padStart(2, "0")) +
                                " "
                            ),
                          ]),
                          _c("div", { staticClass: "colon" }, [_vm._v(":")]),
                          _c("div", { staticClass: "time-unit" }, [
                            _vm._v(
                              " " +
                                _vm._s(String(_vm.minutes).padStart(2, "0")) +
                                " "
                            ),
                          ]),
                          _c("div", { staticClass: "colon" }, [_vm._v(":")]),
                          _c("div", { staticClass: "time-unit" }, [
                            _vm._v(
                              " " +
                                _vm._s(String(_vm.seconds).padStart(2, "0")) +
                                " "
                            ),
                          ]),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _c("hr", { staticClass: "mb-2" }),
                  _c("div", [
                    _vm._v(
                      "Clocked In: " +
                        _vm._s(_vm.getMauritanTime(_vm.clockedIn))
                    ),
                  ]),
                  _c("div", [
                    _vm._v(
                      "Clocked Out: " +
                        _vm._s(_vm.getMauritanTime(_vm.clockedOut))
                    ),
                  ]),
                  _c("hr", { staticClass: "mb-2" }),
                  _vm.dataLoaded && _vm.geolocation
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-content-center align-items-center",
                        },
                        [
                          _c(
                            "div",
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass: "mr-4",
                                  attrs: {
                                    variant: "primary",
                                    disabled: _vm.clockedIn != null,
                                  },
                                  on: { click: _vm.clockIn },
                                },
                                [_vm._v("Clock-In")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            [
                              _c(
                                "b-button",
                                {
                                  attrs: {
                                    variant: "danger",
                                    disabled:
                                      _vm.clockedIn == null ||
                                      _vm.clockedOut != null,
                                  },
                                  on: { click: _vm.clockOut },
                                },
                                [_vm._v("Clock-Out")]
                              ),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                  !_vm.geolocation
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-content-center align-items-center",
                        },
                        [
                          _c("div", [
                            _vm._v(
                              " Loading Geolocation Details ... Please enable location when requested. "
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }